import { Button } from "atoms/button/Button";

import { QuizStepProps } from "../useQuestionnaire";

import { TextAreaStep } from "./components/TextAreaStep";

export const WeightLossMedicationList = (props: QuizStepProps) => {
  const hasError = !!props.errors?.WeightLossMedsList;
  return (
    <div className="flex h-full flex-col gap-3">
      <TextAreaStep
        title="Please list the name, dose, and frequency of your current or recent (within the last 12 months) weight loss medication(s):"
        label="Weight Loss Medications"
        name="WeightLossMedsList"
        value={props.data.WeightLossMedsList as string}
        onChange={props.handleStepData}
        error={hasError}
      />
      {hasError && (
        <p className="text-label text-sm text-red">
          *Please include the name, dose, and frequency of each medication.
        </p>
      )}
      <div>
        <Button onClick={props.next}>Next Question</Button>
      </div>
    </div>
  );
};
